<template>
    <div class="headerAll">
        <transition name="fade" mode="in-out">
            <div :class="{ FixedHeader: true, MenuText: true }" v-if="!scrollTo">
                <div class="logoBlue" @click="goIndex">
                    <img :src="logoPng" alt/>
                    <!-- <div class="version">Beta Version</div> -->
                </div>
                <div class="right">
                    <div class="nav">
                        <p :class="navActive == 'HOME' ? 'isActive' : ''" @click="to_Router('HOME')">
                            <span class="nav_name">HOME</span>
                            <span class="line"></span>
                        </p>
                        <p :class="navActive == 'MESSAGE' ? 'isActive' : ''" @click="to_Router('MESSAGE')">
                            <span class="nav_name">MESSAGE</span>
                            <span class="line"></span>
                        </p>
                        <p :class="navActive == 'EVENTS' ? 'isActive' : ''" @click="to_Router('EVENTS')">
                            <span class="nav_name">EVENT</span>
                            <span class="line"></span>
                        </p>
                        <p :class="navActive == 'VISIBILITY' ? 'isActive' : ''" @click="to_Router('VISIBILITY')">
                            <span class="nav_name">VISIBILITY</span>
                            <span class="line"></span>
                        </p>
                        <p :class="navActive == 'SUBSCRIBE' ? 'isActive' : ''" @click="to_Router('SUBSCRIBE')">
                            <span class="nav_name">SUBSCRIBE</span>
                            <span class="line"></span>
                        </p>
                        <p :class="navActive == 'SUBMIT' ? 'isActive' : ''" @click="to_Router('SUBMIT')">
                            <span class="nav_name">SUBMIT</span>
                            <span class="line"></span>
                        </p>
                        <!--                        <p :class="navActive == 'SUBMITLIST' ? 'isActive' : ''" @click="to_Router('SUBMITLIST')">-->
                        <!--                          <span class="nav_name">SUBMITLIST</span>-->
                        <!--                          <span class="line"></span>-->
                        <!--                        </p>-->
                        <p :class="navActive == 'VIEWDATAINFO' ? 'isActive' : ''" @click="to_Router('VIEWDATAINFO')">
                            <span class="nav_name">VIEW DATA INFO</span>
                            <span class="line"></span>
                        </p>
                        <p :class="navActive == 'ABOUT' ? 'isActive' : ''" @click="to_Router('ABOUT')">
                            <span class="nav_name">ABOUT</span>
                            <span class="line"></span>
                        </p>
                    </div>
                    <div class="MenuIcon" style="margin-right: 35px">
                        <el-dropdown @command="to_Router" trigger="click">
              <span class="el-dropdown-link">
                <i class="el-icon-menu" style="font-size: 25px"></i>
              </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="HOME">HOME</el-dropdown-item>
                                <el-dropdown-item command="MESSAGE">MESSAGE</el-dropdown-item>
                                <el-dropdown-item command="EVENTS">EVENT</el-dropdown-item>
                                <el-dropdown-item command="VISIBILITY">VISIBILITY</el-dropdown-item>
                                <el-dropdown-item command="SUBSCRIBE">SUBSCRIBE</el-dropdown-item>
                                <el-dropdown-item command="SUBMIT">SUBMIT</el-dropdown-item>
                                <!--                                <el-dropdown-item command="SUBMITLIST">SUBMITLIST</el-dropdown-item>-->
                                <el-dropdown-item command="VIEWDATAINFO">VIEW DATA INFO</el-dropdown-item>
                                <el-dropdown-item command="SUBMIT">ABOUT</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <el-popover placement="bottom" width="130" trigger="hover" class="showChange">
                        <div class="showHidden">
                            <div class="userList" v-if="access_token == ''">
                                <p @click="toRou('sign')">Login</p>
                                <p @click="toRou('resign')">Register</p>
                                <!--                              <p @click="toRou('updateinfo')">ADDUSERINFO</p>-->
                                <!--                              <p @click="to_Router('SUBMITLIST')">SUBMITLIST</p>-->
                            </div>
                            <div class="userList" v-else>
                                <p @click="toRou('PersonalCenter')">Personal Center</p>
                                <p @click="toRou('updateinfo')">Add User Info</p>
                                <p @click="to_Router('SUBMITLIST')">Submissions</p>
                                <p @click="toRou('Logout')">Logout</p>


                            </div>
                        </div>
                        <div class="userLogin" slot="reference">
                            <i class="el-icon-user-solid icon"></i>
                        </div>
                    </el-popover>
                </div>
            </div>
        </transition>
        <transition name="fade" mode="in-out">
            <div :class="{ FixedHeader: true, Fixed: scrollTo, MenuText: true }" v-if="scrollTo">
                <div class="logoBlue" @click="goIndex">
                    <img :src="logoPng" alt/>
                </div>
                <div class="right">
                    <div class="nav" style="color: #999999;">
                        <p :class="navActive == 'HOME' ? 'isActive' : ''" @click="to_Router('HOME')">
                            <span class="nav_name">HOME</span>
                            <span class="line"></span>
                        </p>
                        <p :class="navActive == 'MESSAGE' ? 'isActive' : ''" @click="to_Router('MESSAGE')">
                            <span class="nav_name">MESSAGE</span>
                            <span class="line"></span>
                        </p>
                       
                         <p :class="navActive == 'EVENTS' ? 'isActive' : ''" @click="to_Router('EVENTS')">
                            <span class="nav_name">EVENT</span>
                            <span class="line"></span>
                        </p>
                         <p :class="navActive == 'VISIBILITY' ? 'isActive' : ''" @click="to_Router('VISIBILITY')">
                            <span class="nav_name">VISIBILITY</span>
                            <span class="line"></span>
                        </p>
                        <p :class="navActive == 'SUBSCRIBE' ? 'isActive' : ''" @click="to_Router('SUBSCRIBE')">
                            <span class="nav_name">SUBSCRIBE</span>
                            <span class="line"></span>
                        </p>
                        <p :class="navActive == 'SUBMIT' ? 'isActive' : ''" @click="to_Router('SUBMIT')">
                            <span class="nav_name">SUBMIT</span>
                            <span class="line"></span>
                        </p>
                        <!--                        <p :class="navActive == 'SUBMITLIST' ? 'isActive' : ''" @click="to_Router('SUBMITLIST')">-->
                        <!--                          <span class="nav_name">SUBMITLIST</span>-->
                        <!--                          <span class="line"></span>-->
                        <!--                        </p>-->
                        <p :class="navActive == 'VIEWDATAINFO' ? 'isActive' : ''" @click="to_Router('VIEWDATAINFO')">
                            <span class="nav_name">VIEW DATA INFO</span>
                            <span class="line"></span>
                        </p>
                        <p :class="navActive == 'ABOUT' ? 'isActive' : ''" @click="to_Router('ABOUT')">
                            <span class="nav_name">ABOUT</span>
                            <span class="line"></span>
                        </p>
                    </div>
                    <div class="MenuIcon" style="margin-right: 35px">
                        <el-dropdown @command="to_Router" trigger="click">
              <span class="el-dropdown-link">
                <i class="el-icon-menu" style="font-size: 25px"></i>
              </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="HOME">HOME</el-dropdown-item>
                                <el-dropdown-item command="MESSAGE">MESSAGE</el-dropdown-item>
                                <el-dropdown-item command="EVENTS">EVENT</el-dropdown-item>
                                <el-dropdown-item command="VISIBILITY">VISIBILITY</el-dropdown-item>
                                <el-dropdown-item command="SUBSCRIBE">SUBSCRIBE</el-dropdown-item>
                                <el-dropdown-item command="SUBMIT">SUBMIT</el-dropdown-item>
                                <!--                              <el-dropdown-item command="SUBMITLIST">SUBMITLIST</el-dropdown-item>-->
                                <el-dropdown-item command="VIEWDATAINFO">VIEW DATA INFO</el-dropdown-item>
                                <el-dropdown-item command="SUBMIT">ABOUT</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <el-popover placement="bottom" width="130" trigger="hover" class="showChange">
                        <div class="showHidden">
                            <div class="userList" v-if="access_token == ''">
                                <p @click="toRou('sign')">Login</p>
                                <p @click="toRou('register')">Register</p>
                                <!--                                <p @click="toRou('updateinfo')">ADDUSERINFO</p>-->
                                <!--                              <p @click="to_Router('SUBMITLIST')">SUBMITLIST</p>-->
                            </div>
                            <div class="userList" v-else>
                                <p @click="toRou('PersonalCenter')">Personal center</p>
                                <p @click="toRou('Logout')">Logout</p>
                                <!--                              补全用户信息-->
                                <p @click="toRou('updateinfo')">Add User Info</p>
                                <!--                              个人提交记录-->
                                <p @click="to_Router('SUBMITLIST')">Submissions</p>
                            </div>
                        </div>
                        <div class="userLogin" slot="reference">
                            <i class="el-icon-user-solid icon"></i>
                        </div>
                    </el-popover>
                </div>
            </div>
        </transition>
        <div class="img" v-if="imgBg">
            <div class="userInfo">
                <div
                        class="userName"
                        v-if="navActive != 'EVENTS' && navActive != 'MESSAGE'"
                >Welcome, {{ userInfo.truename }}!
                </div>
                <div class="info" v-if="navActive != 'EVENTS' && navActive != 'MESSAGE'">
                    <div class="Organization">
                        <div class="img1"></div>
                        <p>Organization: Organization Title</p>
                    </div>
                    <div class="Email">
                        <div class="img2"></div>
                        <p>Email:{{ userInfo.cstnetId }}</p>
                    </div>
                </div>
            </div>
            <div
                    class="subName"
                    v-if="this.$route.meta.desc == undefined"
            >{{ this.$route.meta.title == 'EVENTS'?'EVENT': this.$route.meta.title}}
            </div>
            <div
                    class="subName"
                    v-else
            >{{ this.$route.meta.desc == 'EVENTS'?'EVENT': this.$route.meta.desc}}
            </div>
        </div>
        <el-dialog
                title="Tips"
                width="600px"
                top="200px"
                :show-close="false"
                :visible.sync="dialogVisible"
        >
            <div class="dialog-top">Experience more features after login</div>
            <div class="dialog-botton">
                <div class="botton-left" @click="dialogVisible = false">
                    <p>Cancel</p>
                </div>
                <div class="botton-right" @click="tiaozhuan">
                    <p>Login</p>
                </div>
            </div>
            <div class="dialog-icon">
                <i class="el-icon-circle-close" @click="dialogVisible = false"></i>
            </div>
        </el-dialog>

        <!--    补全用户信息弹框-->
        <el-dialog :visible.sync="userinfoDialogVisible" title="Complete the information"
                   :close-on-click-modal="false">
            <el-form ref="dialogForm" :model="newUserFormData">
                <el-form-item label="The purpose of issuing the alert：">
                    <el-input v-model="newUserFormData.objective" v-bind:disabled="showUpSubmitAprove"></el-input>
                </el-form-item>

                <el-form-item label="Owning device and Group：">
                    <el-input v-model="newUserFormData.device" v-bind:disabled="showUpSubmitAprove"></el-input>
                </el-form-item>

                <!--          <el-form-item label="Belongs to the task group：">-->
                <!--            <el-input v-model="newUserFormData.taskForce"></el-input> v-if="showUpSubmit" -->
                <!--          </el-form-item>-->
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleDialogSubmit" v-if="showUpSubmit">Save and continue</el-button>
          <el-button type="warning" v-if="showUpSubmitAprove">Wait for approval</el-button>
          <el-button type="success" v-if="showApproveDone">Approved</el-button>
      </span>
        </el-dialog>

        <!--      跳转前说明-->
        <el-dialog
                :title="reTitle"
                :visible.sync="reDialogVisible"
                width="50%"
                :append-to-body="true" >
            <div style="width: 100%;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="changeLanguage()">{{language}}</el-button>
            </div>
            <div class="dialog_id" v-if="languageChange==false">
                <p>注册说明</p>
                <p>本系统支持高能所统一认证登录，使用前需先注册高能所统一认证账号。具体步骤如下：</p>
                <p>第一步，打开高能所统一认证注册页面<a
                        href="https://login.ihep.ac.cn/registlight.jsp">https://login.ihep.ac.cn/registlight.jsp</a></p>
                <img src="@/assets/img1.png" style="width: 100%;"></img>
                <p>第二步，按页面提示进行注册。</p>
                <p>第三步，注册完成后，回到天文警报汇主页，使用高能所统一认证账号登录系统。</p>

            </div>
            <div class="dialog_id" v-else>
                <p>How to Register </p>
                <p>1) IHEP SSO Account is needed. Click <a href="https://login.ihep.ac.cn/registlight.jsp">here</a> to register IHEP SSO Account.</p>
                <img src="@/assets/img2.png" style="width: 100%;"></img>
                <p>2) Follow the prompts on the page to register. Answer all the questions on this page.</p> 
                <p>3) After submitting your information, the system will send you a verified email automatically.</p>
                <img src="@/assets/img3.png" style="width: 100%;"></img>
                <p>Login your email，</p>
                <p>Click the link listed in this email to verify your registration.</p>
                <img src="@/assets/img4.png" style="width: 100%;"></img>
                <p>Then your IHEPSSO account will be activated.</p>
                <img src="@/assets/img5.png" style="width: 100%;"></img>
                <p>4) Once registration is complete, return to the home page, login using IHEPSSO.</p>

            </div>
            <span slot="footer" class="dialog-footer">

        <el-button type="primary" @click="handleClose('ok')">CONFIRM</el-button>
        <el-button @click="handleClose('cancle')">CANCLE</el-button>
  </span>
        </el-dialog>

    </div>
</template>

<script>
    import {redirectUrl} from "@/utils/index.js";
    import qs from "qs";

    export default {
        name: "indexHeader",
        props: {
            imgBg: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                navActive: this.$route.meta.title,
                language: '中文',
                reTitle: 'Instructions for Registered Users',
                dialogVisible: false,
                userinfoDialogVisible: false,
                reDialogVisible: false,
                showHidden: false,
                showHidden1: false,
                scrollTo: false,
                access_token: "",
                logoPng: "",
                nowPath: "",
                userInfo:
                    localStorage.getItem("userInfo") != undefined
                        ? JSON.parse(localStorage.getItem("userInfo"))
                        : {
                            truename: "未知用户"
                        },
                newUserFormData: {
                    objective: '',
                    device: '',
                    taskForce: '',
                    loginName: '',
                    email: '',
                    name: ''
                },
                reContext: '',
                languageChange: true,
                showUpSubmit: true,
                showUpSubmitAprove: false,
                showApproveDone: false,
            };
        },
        created() {
            console.log("created:");
            console.log("window.location.href:");
            console.log(window.location.href);
            
            var b = window.location.href.split("code=");
            console.log(b);
            if (b.length == 2) {
                this.access_token = "123123";
            }
            console.log(localStorage.getItem("access_token"));
            if (localStorage.getItem("access_token")) {
                this.access_token = localStorage.getItem("access_token");
            } else {
            }
            console.log("this.access_token:");
            console.log(this.access_token);
        },
        mounted() {
            console.log("mounted  redirectUrl: 默认http://tianwen.dev.vrsea.cn/");
            console.log(JSON.parse(localStorage.getItem("userInfo")));
            console.log(redirectUrl);
            if (localStorage.getItem("personCenter")) {
            } else {
                if (localStorage.getItem("metaTitle")) {
                    this.navActive = localStorage.getItem("metaTitle");
                    this.$route.meta.title = this.navActive;
                    console.log("读取本地存储");
                } else {
                    this.navActive = this.$route.meta.title;
                }
            }
            this.logoPng = localStorage.getItem("logoPng");
            this.getData();
            console.log(JSON.parse(localStorage.getItem("userInfo")));
        },
        methods: {
            goIndex() {
                this.$router.push("/indexPage");
            },
            getData() {
                this.$fetchGet("/cms-middle/cmsSite/config?type=basic")
                    .then(result => {
                        if (!this.logoPng) {
                            this.logoPng =
                                process.env.VUE_APP_ENV + result.config.logo.description;
                        }
                    })
                    .catch(err => {
                    });
            },
            scrollToTop() {
                let scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                //为了计算距离顶部的高度，当高度大于50显示回顶部图标，小于50则隐藏
                if (scrollTop > 1) {
                    this.scrollTo = true;
                } else {
                    this.scrollTo = false;
                }
            },
            to_Router(sub) {
                console.log("to_Router:");
                localStorage.removeItem("metaTitle");
                localStorage.removeItem("personCenter");
                let token = localStorage.getItem("access_token");
                if (this.$route.meta.title == sub && this.$route.meta.desc == undefined) {
                    window.location.reload();
                } else {
                    if (sub == "SUBMIT") {
                        if (!token) {
                            this.dialogVisible = true;
                            // this.$router.push("/submit");
                        } else {
                            this.$router.push("/submit");
                        }
                    } else if (sub == "SUBMITLIST") {
                        if (!token) {
                            this.dialogVisible = true;
                            // this.$router.push("/submitList");
                        } else {
                            this.$router.push("/submitList");
                        }
                    } else if (sub == "VIEWDATAINFO") {
                        this.$router.push("/viewDataInfo");
                    } else if (sub === "HOME") {
                        this.$router.push("/indexPage");
                    } else if (sub === "SUBSCRIBE") {
                        if (!token) {
                            this.dialogVisible = true;
                        } else {

                            this.$router.push("/subscribe");
                        }
                    } else if (sub === "MESSAGE") {
                        this.$router.push("/message");
                    } else if (sub === "EVENTS") {
                        this.$router.push("/events");
                    } else if (sub === "VISIBILITY") {
                        this.$router.push("/target_visibility");
                    } else if (sub === "ABOUT") {
                        this.$router.push("/about");
                    }
                }
                localStorage.setItem("navActive", sub);
            },
            tiaozhuan() {
                window.location = "https://login.ihep.ac.cn/oauth2/authorize?response_type=code&redirect_uri=http://www.astrobursthub.cn/&client_id=37435&theme=full";
                //window.location = "https://login.ihep.ac.cn/oauth2/authorize?response_type=code&redirect_uri=https://astrongertest.c2.eplus.org.cn/&client_id=44232&theme=full";
            },
            logout() {
                localStorage.removeItem("code");
                localStorage.removeItem("access_token");
                localStorage.removeItem("userInfo");

                //  "https://login.ihep.ac.cn/logout?WebServerURL=http://www.astrobursthub.cn";
                window.location = "https://login.ihep.ac.cn/logout?WebServerURL=http://www.astrobursthub.cn";
            },
            toRou(sub) {
                console.log("toRou:");
                if (this.$route.meta.title == sub) {
                    console.log("toRou: sub");
                    window.location.reload();
                } else {
                    if (sub == "sign") {
                        console.log("toRou: sub sign");
                        this.tiaozhuan();
                        // localStorage.setItem("cookie", "user");
                    } else if (sub == "resign") {
                        console.log("toRou: sub resign");
                        this.reDialogVisible = true;
                    } else if (sub == "PersonalCenter") {
                        console.log("toRou: sub PersonalCenter");
                        this.$router.push("/PersonalCenter");
                    } else if (sub === "Logout") {
                        this.logout();
                        // this.$fetchGet("/cms-middle/member/logout")
                        //   .then((result) => {
                        //     localStorage.removeItem("code");
                        //     localStorage.removeItem("access_token");
                        //     if (this.$route.meta.title != "HOME") {
                        //       this.$router.push("/");
                        //     } else {
                        //       window.location.reload();
                        //     }
                        //     //
                        //   })
                        //   .catch((err) => {
                        //     this.$message.error(err);
                        //   });
                    } else if (sub == "register") {
                        // this.reDialogVisible=true;
                        console.log("toRou: sub register");
                        this.$router.push("/RegisterInstructions")
                    } else if (sub === "updateinfo") {
                        console.log("toRou: sub updateinfo");
                        let token = localStorage.getItem('access_token')
                        if (!token) {
                            this.dialogVisible = true;
                        } else {
                            this.userinfoDialogVisible = true;
                            // this.newUserFormData.loginName = JSON.parse(localStorage.getItem('userInfo')).cstnetId;
                            // this.newUserFormData.email = JSON.parse(localStorage.getItem('userInfo')).cstnetId;
                            // this.newUserFormData.name = JSON.parse(localStorage.getItem('userInfo')).truename;
                            //获取用户信息
                            console.log("toRou: sub updateinfo 获取用户信息");
                            this.$fetchPost("/cms-middle/astronCustomize/getUserInfoByEmail?userEmail=" + JSON.parse(localStorage.getItem('userInfo')).cstnetId)
                                // this.$fetchPost("/cms-middle/astronCustomize/getUserInfoByEmail?userEmail=1156522566@qq.com")
                                .then(result => {
                                    if (result.status == 2) {
                                        this.newUserFormData.objective = result.user.objective;
                                        this.newUserFormData.device = result.user.device;
                                        this.showUpSubmit = false;
                                        this.showUpSubmitAprove = false;
                                        this.showApproveDone = true;
                                    } else if (result.status == 0) {
                                        //表示没有
                                        this.showUpSubmit = true;
                                        this.showUpSubmitAprove = false;
                                        this.showApproveDone = false;
                                    } else {
                                        this.showUpSubmit = false;
                                        this.showUpSubmitAprove = true;
                                        this.showApproveDone = false;
                                        this.newUserFormData.objective = result.user.objective;
                                        this.newUserFormData.device = result.user.device;
                                    }
                                })
                                .catch(err => {
                                });
                        }
                    }
                }
            },
            //补全用户信息
            handleDialogSubmit() {
                // 提交新用户信息表单
                console.log("提交新用户信息",this.newUserFormData);
                this.$refs.dialogForm.validate(valid => {
                    if (valid) {
                        this.$http
                            .post("/sys/user/submitSave?" + qs.stringify(this.newUserFormData))
                            .then((res) => {
                                    this.$message.success("Submitted successfully");
                                    this.userinfoDialogVisible = false;
                                }
                            );
                    } else {
                        console.log('表单验证失败');
                        this.userinfoDialogVisible = false;
                    }
                });
            },
            //注册提示关闭
            handleClose(done) {
                if (done == 'ok') {
                    this.$confirm('Whether the registration steps are clear?')
                        .then(_ => {
                            // this.tiaozhuan();
                            this.reDialogVisible = false;
                            window.location = "https://login.ihep.ac.cn/registlight.jsp"
                        })
                        .catch(_ => {
                            //出错了
                        });
                } else {
                    this.reDialogVisible = false;
                }
            },
            changeLanguage() {
                if (this.languageChange) {
                    this.languageChange = false;
                    this.language = 'English';
                } else {
                    this.languageChange = true;
                    this.language = "中文";
                }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .dialog_id p {
        text-align: left;
    }

    .version {
        color: #ffffff;
        position: absolute;
        right: -100px;
        top: 0;
    }

    .fade-enter {
        opacity: 0;
    }

    .fade-leave {
        opacity: 1;
    }

    .fade-enter-active {
        transition: opacity 0.5s;
    }

    .fade-leave-active {
        opacity: 0;
        transition: opacity 0.5s;
    }

    .nav_name {
        font-weight: 700;
    }

    .logoBlue {
        padding-left: 24px;
        position: relative;
    }

    .Fixed {
        position: fixed;
        top: 0;
        z-index: 99999999;
        left: 0;
        /* border-bottom: 1px solid #ccc; */
        background-color: #ffffff;
    }

    .img {
        width: 100%;
        height: 223px;
        background: url(@/assets/slices_slices/banner_02.png) no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        z-index: 0;
        display: flex;
        justify-content: space-around;
        /* align-items: center; */
    }

    .userInfo {
        margin-top: 36px;
        text-align: left;
        min-width: 338px;
        flex: 1;
        margin-left: 13.8%;
    }

    .info,
    .Organization,
    .Email {
        display: flex;
        font-size: 12px;
        color: #fff;
        align-items: center;
    }

    .Email {
        margin-left: 10px;
    }

    .userName {
        color: #89ccea;
        font-size: 17px;
        font-weight: bold;
    }

    .subName {
        height: 25px;
        font-size: 31px;
        font-family: Alibaba Sans;
        font-weight: bold;
        color: #ffffff;
        margin-right: 13.8%;
        margin-top: 43px;
    }

    .img1 {
        width: 12px;
        height: 12px;
        background: url(@/assets/slices_slices/img1.png) no-repeat center center;
        background-size: 100% 100%;
        margin-right: 5px;
    }

    .img2 {
        width: 15px;
        height: 12px;
        background: url(@/assets/slices_slices/img2.png) no-repeat center center;
        background-size: 100% 100%;
        margin-right: 5px;
    }

    .FixedHeader {
        width: 100%;
        height: 68px;
        /* background: #ffffff; */
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .nav {
        color: #666666;
        color: #ffffff;
        font-size: 15px;
        display: flex;
         /*width: 609px; */
        justify-content: space-between;
        margin-right: 30px;
    }

    .nav p {
        cursor: pointer;
        margin-right: 12px;
    }

    .logo {
        /* width: 125px; */
        font-size: 30px;
        font-family: Alibaba Sans;
        font-weight: normal;
        color: #168ec7;
        margin-left: 43px;
    }

    .right {
        display: flex;
        align-items: center;
    }

    .userLogin {
        width: 41px;
        height: 41px;
        background: #168ec7;
        border-radius: 50%;
        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        margin-right: 50px;
        margin-left: 25px;
    }

    .showChange {
        position: relative;
    }

    .icon {
        color: #fff;
        width: 20px;
        height: 20px;
    }

    .name {
        font-size: 11px;
        font-family: ArialMT-, ArialMT;
        font-weight: normal;
        color: #ffffff;
        cursor: pointer;
        line-height: 11px;
    }

    .button {
        margin-left: 20px;
        margin-right: 10px;
    }

    .login {
        width: 86px;
        height: 24px;
        background: #168ec7;
        border-radius: 12px;
        text-align: center;
        font-size: 15px;
        font-family: Arial;
        font-weight: bold;
        color: #ffffff;
        line-height: 24px;
    }

    .nav p {
        position: relative;
    }

    .line {
        width: 130%;
        height: 2px;
        background: #168ec7;
        position: absolute;
        bottom: -20px;
        left: -15%;
        display: block;
        opacity: 0;
    }

    .nav p.isActive {
        color: #168ec7;
    }

    .nav p.isActive .line {
        opacity: 1;
    }

    /* .userList {
      background: #fff;
      width: 135px;
      height: 70px;
      position: absolute;
      border-radius: 5px;
      bottom: -95px;
      right: -40px;
      z-index: 999;
    }
    .userList::after {
      content: "";
      width: 0;
      height: 0;
      border: 10px solid;
      position: absolute;
      top: -20px;
      left: 60px;
      border-color: transparent transparent white;
    }*/
    .userList p {
        margin: 0 8px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
    }

    .userList p:hover {
        background: #e7f3f9;
        cursor: pointer;
    }

    .MenuIcon {
        display: none;
    }

    .dialog-top {
        text-align: center;
    }

    .dialog-footer > p,
    .dialog-top > p {
        font-size: 16px;
        font-family: Alibaba Sans;
        font-weight: bold;
        text-align: center;
        color: #333333;
    }

    .dialog-footer {
        display: flex;
    }

    .dialog-footer > p {
        margin-top: 0px;
    }

    /deep/ .el-checkbox__label {
        font-size: 14px;
        font-family: Alibaba Sans;
        font-weight: 400;
        color: #333333;
    }

    .dialog-checkbox {
        margin-left: 30px;
    }

    .dialog-input {
        margin-left: 24px;
        flex: 1;
    }

    .dialog-botton {
        display: flex;
        margin-top: 32px;
        width: 100%;
        justify-content: center;
    }

    .botton-left {
        width: 83px;
        height: 33px;
        background: #e6ebf3;
        border-radius: 17px;
        text-align: center;
        cursor: pointer;
        margin-right: 10px;
    }

    .botton-left > p {
        font-size: 14px;
        height: 33px;
        font-family: Alibaba Sans;
        font-weight: bold;
        color: #666666;
        line-height: 4px;
    }

    .botton-right {
        width: 83px;
        height: 33px;
        background: #168ec7;
        border-radius: 17px;
        text-align: center;
        cursor: pointer;
    }

    .botton-right > p {
        font-size: 14px;
        height: 33px;
        font-family: Alibaba Sans;
        font-weight: bold;
        color: #ffffff;
        line-height: 4px;
    }

    .el-dialog__body {
        position: relative;
    }

    .dialog-icon {
        position: absolute;
        right: 16px;
        top: 16px;
    }

    .el-icon-circle-close {
        font-size: 23px;
        color: #168ec7;
        cursor: pointer;
    }
</style>
<style lang="less" scoped>
    .el-popover {
        min-width: 100px;
        padding: 8px !important;
    }
</style>
